import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Models from "@/pages/Models";
import ModelDetail from "@/pages/ModelDetail";
import TestDrive from "@/pages/TestDrive";
import Contact from "@/pages/Contact";
import Fleet from "@/pages/Fleet";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/modelle" element={<Models />} />
            <Route path="/modelle/:slug" element={<ModelDetail />} />
            <Route path="/galerie" element={<Gallery />} />
            <Route path="/probefahrt" element={<TestDrive />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/flotten" element={<Fleet />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
